import { MatchDetailsStylesSchema } from './NewMatchDetailsPage.styles';

export const matchDetailsStyles: MatchDetailsStylesSchema = {
  headerFlex: {
    justify: 'space-between',
    alignItems: 'center',
  },
  headerHeading: {
    fontSize: ['md', '2xl', '2xl'],
    textShadow: '0px 4px 3px rgba(0, 0, 0, 0.15)',
    fontFamily: 'CreteRound',
    color: 'epsilon.100',
    textTransform: 'capitalize',
  },
  headerIconButton: {
    color: 'beta.200',
    p: '1',
    size: 'xs',
    variant: 'link',
    _hover: {
      opacity: '.8',
    },
  },
  headerSkeletonText: {},
  headerVsBox: {
    color: 'beta.200',
    px: 2,
    textTransform: 'lowercase',
  },

  bodyStack: {
    px: ['2.5', null, null, '3'],
    minH: '90vh',
  },
  bodyInnerWrapper: {},
  sgmLogo: {
    color: 'beta.500',
    h: '3',
    ml: '1',
    w: 'auto',
  },
  scrollButtonGroup: {
    variant: 'filter',
    bg: 'none',
    boxShadow: 'none',
  },
  toMarketButton: {
    fontFamily: 'roboto',
    fontSize: 'xs',
    borderColor: 'beta.400',
    color: 'white',
    _hover: {
      color: 'beta.400',
    },
    sx: {
      '&[data-active]': {
        bg: 'beta.400',
        color: 'alpha.600',
        _after: {
          pos: 'relative',
          top: 'unset',
          right: '-2px',
        },
      },
    },
    _last: { mr: 2 },
  },
  loadingSkeletonText: {
    my: '4',
    spacing: '4',
    skeletonHeight: '2',
  },

  accordion: {
    display: 'flex',
    flexDir: ['column', null, null, 'row'],
    mx: '-1',
    sx: {
      '& .chakra-collapse': {
        overflow: 'visible !important',
      },
    },
  },
  accordionStack: {
    px: '1',
    w: { lg: '50%' },
    _notFirst: {
      mt: ['2', null, null, '0'],
    },
  },
  accordionItem: {
    border: '0',
    borderRadius: 'base',
    boxShadow:
      '0 3px 5px rgba(0, 0, 0, .2), 0 1px rgba(255, 255, 255, .15) inset',
    overflow: 'hidden',
  },
  accordionButton: {
    fontSize: 'xs',
    fontWeight: 'bold',
    p: '2',
    textAlign: 'left',
    bgGradient: 'linear(to-b, gamma.400, gamma.500)',
    _expanded: {
      boxShadow:
        '0px -1px 0px 0px rgba(255, 255, 255, 0.20) inset, 0px -2px 0px 0px rgba(0, 0, 0, 0.15) inset',
    },
    _hover: {
      bgGradient: 'linear(to-b, gamma.500, gamma.600)',
    },
  },

  marketLayoutIconFlex: {
    align: 'center',
    flex: '1',
    gap: '1',
    color: 'alpha.600',
  },
  marketLayoutTooltip: {},
  marketLayoutIcon: {
    color: 'alpha.500',
    fontSize: 'lg',
  },
  marketLoadingCenter: {},
  centerLoadingSpinner: {},
  marketLayoutLoadedIcon: {},
  marketLayoutAccordionPanel: {
    bg: 'white',
    p: '0',
  },

  cancelButton: {
    variant: 'solid',
    px: '3',
  },
  clearButton: {
    variant: 'solid',
    ml: '3',
    px: '3',
  },
  countdown: {
    sx: {
      textTransform: 'uppercase',
      '&&&.state-prior': {
        px: 2,
        py: 0,
        lineHeight: 'initial',
      },
    },
  },
  sgmLogoV2: {
    color: 'white',
    w: '8',
    h: 'auto',
  },
  wrapperScrollSgm: { 
    w: '100%', 
    maxW: '100%', 
    gap: '2', 
    mt: '2',
    overflowX: 'auto',
    sx: {
      '&::-webkit-scrollbar': { display: 'none' },
    },
  },
  scrollButtonGroupV2: {
    variant: 'unstyled',
    flex: 1,
    position: 'relative',
    minH: '34px',
    maxW: '100%',
    bg: 'none',
    boxShadow: 'none',
  },
  accordionItemActive: {
    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)',
  },
  toMarketButtonV2: {
    color: 'white',
    fontSize: 'xs',
    textTransform: 'uppercase',
    minW: 'fit-content',
    fontWeight: 'bold',
    cursor: 'pointer',

    sx: {
      '&&': {
        px: 2,
        ml: 0,
      },
      '&[data-active]': {
        color: 'epsilon.500',
      },

      '.chakra-button__icon': {
        margin: 0,
      },
    },

    _last: { mr: 2 },
  },
  sgmBtn: {
    bgGradient: 'linear(to-b, beta.500, beta.500)',
    boxShadow:
      '0px 2px 2px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 4px #006352 inset',
    h: '48px',
    borderWidth: '2px',
    borderColor: 'epsilon.500',
    borderStyle: 'solid',
    sx: {
      bgGradient: 'linear(to-b, beta.500, beta.500)',
      svg: {
        color: 'white',
        fill: 'white',
      },
    },
  },
  sgmBtnActive: {
    sx: {
      svg: {
        color: '#72D704',
        fill: '#72D704',
      },

      '&&': {
        boxShadow: 'none',
        border: 'none',
        bg: 'alpha.800',
        textShadow: '0px 0px 8px rgba(251, 201, 21, 0.50)',
      },
    },

    _after: { display: 'none' },
  },
};
